import { render, staticRenderFns } from "./MarkPostCreate.vue?vue&type=template&id=28ee0528&scoped=true"
import script from "./MarkPostCreate.vue?vue&type=script&lang=js"
export * from "./MarkPostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee0528",
  null
  
)

export default component.exports